import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) { }

  openDialog(dialogType, width = '350px', data: any = null) {
    const dialogRef = this.dialog.open(dialogType, {
      width: width,
      data: data,
      autoFocus: false,
      panelClass: 'mvrdv-modal'
    });

    return dialogRef.afterClosed();
  }
}
